<script setup lang="ts">
import Dialog from 'primevue/dialog';
import DSButton from 'primevue/button';
import { useRouter } from 'vue-router';
import { RouteNames } from '@/data/routes';

const visible = defineModel<boolean>({ required: true });
const router = useRouter();
</script>

<template>
  <Dialog
    v-model:visible="visible"
    header="Sign Out of Your Account"
    modal
    closable
    :draggable="false"
    :closeOnEscape="false"
    style="width: 550px; max-width: 90vw"
  >
    <div class="content">
      <p class="text-center">
        Are you sure you would like to sign out of your account?
      </p>
    </div>

    <template #footer>
      <DSButton
        label="Yes, Sign Out"
        @click="() => router.push({ name: RouteNames.AUTH.LOGOUT })"
        class="w-full"
      />
    </template>
  </Dialog>
</template>
